'use client'

import { ChildrenProps } from 'react'
import { Provider } from 'react-redux'

import { store } from '@/redux/store'

export default function ReduxProvider({ children }: ChildrenProps) {
  return <Provider store={store}>{children}</Provider>
}
